var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-md-8" },
      [
        _c(
          "div",
          { staticClass: "form-group" },
          [
            _vm._v("\n      Адрес\n      "),
            _vm.$editNewOrder.extra_options?.address
              ? _c("div", { staticClass: "text-muted" }, [
                  _c("p", { staticClass: "mb-0" }, [_vm._v("Адрес с сайта")]),
                  _vm._v(" "),
                  _c("p", { staticClass: "mb-0" }, [
                    _vm._v(_vm._s(_vm.$editNewOrder.extra_options.address)),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            !+_vm.$editNewOrder.city_id
              ? _c("div", { staticClass: "alert alert-info" }, [
                  _vm._v(
                    "\n        для заявок с отправкой по почте, адрес должен начинаться с индекса\n      "
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.$platformConstants.citiesWithoutAddressValidation.includes(
              +_vm.$editNewOrder.city_id
            )
              ? [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.$editNewOrder.address,
                        expression: "$editNewOrder.address",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text", placeholder: "Адрес доставки" },
                    domProps: { value: _vm.$editNewOrder.address },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.$editNewOrder,
                          "address",
                          $event.target.value
                        )
                      },
                    },
                  }),
                ]
              : [
                  _c("AddressApi", {
                    ref: "APIaddress",
                    attrs: {
                      selected: _vm.$editNewOrder.address,
                      onSelect: _vm.updateAddress,
                    },
                  }),
                ],
          ],
          2
        ),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _vm._v("\n      Детали (код домофона, квартира и тд)\n      "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.$editNewOrder.extra_options.address_details,
                expression: "$editNewOrder.extra_options.address_details",
              },
            ],
            staticClass: "form-control",
            attrs: { type: "text" },
            domProps: {
              value: _vm.$editNewOrder.extra_options.address_details,
            },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(
                  _vm.$editNewOrder.extra_options,
                  "address_details",
                  $event.target.value
                )
              },
            },
          }),
        ]),
        _vm._v(" "),
        _vm.$AllCities[_vm.$editNewOrder.city_id] &&
        _vm.$AllCities[_vm.$editNewOrder.city_id].use_metro
          ? _c("div", { staticClass: "form-group" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _vm._v("\n        Ближайшее метро\n        "),
                  _c(
                    "v-select",
                    {
                      attrs: {
                        label: "title",
                        placeholder: "Метро",
                        filterable: false,
                        options: _vm.metroList,
                      },
                      on: { search: _vm.onSearchMetro },
                      nativeOn: {
                        keypress: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          $event.preventDefault()
                        },
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "option",
                            fn: function (option) {
                              return [
                                _c("div", { staticClass: "d-center" }, [
                                  _vm._v(
                                    "\n              " + _vm._s(option.title)
                                  ),
                                  _c("br"),
                                  _vm._v(
                                    _vm._s(option.line.title) + "\n            "
                                  ),
                                ]),
                              ]
                            },
                          },
                          {
                            key: "selected-option",
                            fn: function (option) {
                              return [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(option.title) +
                                    "\n          "
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2208843840
                      ),
                      model: {
                        value: _vm.$editNewOrder.metro_station,
                        callback: function ($$v) {
                          _vm.$set(_vm.$editNewOrder, "metro_station", $$v)
                        },
                        expression: "$editNewOrder.metro_station",
                      },
                    },
                    [
                      _c("template", { slot: "no-options" }, [
                        _vm._v(
                          "\n            введите название станции..\n          "
                        ),
                      ]),
                    ],
                    2
                  ),
                ],
                1
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        [7].includes(_vm.$editNewOrder.division_id)
          ? [
              _c("div", { staticClass: "form-group" }, [
                _vm._v("\n        Трэк номер\n        "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.$editNewOrder.track_number,
                      expression: "$editNewOrder.track_number",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { disabled: false, type: "text" },
                  domProps: { value: _vm.$editNewOrder.track_number },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.$editNewOrder,
                        "track_number",
                        $event.target.value
                      )
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._v("\n        Почтовые расходы\n        "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.$editNewOrder.post_expenses,
                      expression: "$editNewOrder.post_expenses",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { type: "number" },
                  domProps: { value: _vm.$editNewOrder.post_expenses },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.$editNewOrder,
                        "post_expenses",
                        $event.target.value
                      )
                    },
                  },
                }),
              ]),
            ]
          : _vm._e(),
      ],
      2
    ),
    _vm._v(" "),
    _c("div", { staticClass: "col-md-4" }, [
      _c(
        "div",
        { staticClass: "form-group mb-1" },
        [
          _vm._v("\n      Дата планируемой доставки\n      "),
          _c("OrderDateSelect", {
            ref: "selectedDate",
            attrs: {
              disabled: true,
              onSelect: (date) => _vm.updateDeliveryDate(date),
              selectedDate: _vm.deliveryDate,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.$editNewOrder.city_id !== null
        ? _c(
            "div",
            {
              class: {
                "mb-1 alert": true,
                "alert-info": _vm.ordersInProgress < _vm.maxOrdersQty,
                "alert-danger": _vm.ordersInProgress >= _vm.maxOrdersQty,
              },
            },
            [
              _vm._v("\n      Заявок в работе: "),
              _c("strong", [_vm._v(_vm._s(_vm.ordersInProgress))]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _vm._v("\n      Расчет зарплаты\n      "),
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.$editNewOrder.extra_options.salary_rate,
                expression: "$editNewOrder.extra_options.salary_rate",
              },
            ],
            staticClass: "form-control",
            on: {
              change: function ($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function (o) {
                    return o.selected
                  })
                  .map(function (o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.$set(
                  _vm.$editNewOrder.extra_options,
                  "salary_rate",
                  $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                )
              },
            },
          },
          [
            _c("option", { attrs: { value: "0" } }, [
              _vm._v("по низкой ставке"),
            ]),
            _vm._v(" "),
            _c("option", { attrs: { value: "1" } }, [
              _vm._v("по высокой ставке"),
            ]),
            _vm._v(" "),
            _c("option", { attrs: { value: "2" } }, [
              _vm._v("по дальней ставке"),
            ]),
            _vm._v(" "),
            _c("option", { attrs: { value: "999" } }, [
              _vm._v("произвольная сумма"),
            ]),
          ]
        ),
      ]),
      _vm._v(" "),
      _vm.$editNewOrder.extra_options.salary_rate == 999
        ? _c("div", { staticClass: "form-group" }, [
            _vm._v("\n      Сумма зарплаты\n      "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.$editNewOrder.extra_options.custom_salary,
                  expression: "$editNewOrder.extra_options.custom_salary",
                },
              ],
              staticClass: "form-control",
              attrs: { type: "number" },
              domProps: {
                value: _vm.$editNewOrder.extra_options.custom_salary,
              },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(
                    _vm.$editNewOrder.extra_options,
                    "custom_salary",
                    $event.target.value
                  )
                },
              },
            }),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "form-check" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.$editNewOrder.extra_options.call_day_before,
              expression: "$editNewOrder.extra_options.call_day_before",
            },
          ],
          staticClass: "form-check-input",
          attrs: { checked: "", type: "checkbox", id: "gridCheck1" },
          domProps: {
            checked: Array.isArray(
              _vm.$editNewOrder.extra_options.call_day_before
            )
              ? _vm._i(_vm.$editNewOrder.extra_options.call_day_before, null) >
                -1
              : _vm.$editNewOrder.extra_options.call_day_before,
          },
          on: {
            change: function ($event) {
              var $$a = _vm.$editNewOrder.extra_options.call_day_before,
                $$el = $event.target,
                $$c = $$el.checked ? true : false
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v)
                if ($$el.checked) {
                  $$i < 0 &&
                    _vm.$set(
                      _vm.$editNewOrder.extra_options,
                      "call_day_before",
                      $$a.concat([$$v])
                    )
                } else {
                  $$i > -1 &&
                    _vm.$set(
                      _vm.$editNewOrder.extra_options,
                      "call_day_before",
                      $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                    )
                }
              } else {
                _vm.$set(
                  _vm.$editNewOrder.extra_options,
                  "call_day_before",
                  $$c
                )
              }
            },
          },
        }),
        _vm._v(" "),
        _c(
          "label",
          { staticClass: "form-check-label", attrs: { for: "gridCheck1" } },
          [_vm._v("\n        Позвонить за день до доставки\n      ")]
        ),
      ]),
      _vm._v(" "),
      _vm.$editNewOrder.city_id != 0
        ? _c("div", { staticClass: "form-check" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value:
                    _vm.$editNewOrder.extra_options.call_hour_before_delivery,
                  expression:
                    "$editNewOrder.extra_options.call_hour_before_delivery",
                },
              ],
              staticClass: "form-check-input",
              attrs: { type: "checkbox", id: "gridCheck2" },
              domProps: {
                checked: Array.isArray(
                  _vm.$editNewOrder.extra_options.call_hour_before_delivery
                )
                  ? _vm._i(
                      _vm.$editNewOrder.extra_options.call_hour_before_delivery,
                      null
                    ) > -1
                  : _vm.$editNewOrder.extra_options.call_hour_before_delivery,
              },
              on: {
                change: function ($event) {
                  var $$a =
                      _vm.$editNewOrder.extra_options.call_hour_before_delivery,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 &&
                        _vm.$set(
                          _vm.$editNewOrder.extra_options,
                          "call_hour_before_delivery",
                          $$a.concat([$$v])
                        )
                    } else {
                      $$i > -1 &&
                        _vm.$set(
                          _vm.$editNewOrder.extra_options,
                          "call_hour_before_delivery",
                          $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                        )
                    }
                  } else {
                    _vm.$set(
                      _vm.$editNewOrder.extra_options,
                      "call_hour_before_delivery",
                      $$c
                    )
                  }
                },
              },
            }),
            _vm._v(" "),
            _c(
              "label",
              { staticClass: "form-check-label", attrs: { for: "gridCheck2" } },
              [
                _vm._v(
                  "\n        Обязательно позвонить за час до доставки\n      "
                ),
              ]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.checkDeliveryBefore
        ? _c("div", { staticClass: "form-check" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.$editNewOrder.extra_options.possible_early,
                  expression: "$editNewOrder.extra_options.possible_early",
                },
              ],
              staticClass: "form-check-input",
              attrs: { type: "checkbox", id: "gridCheck3" },
              domProps: {
                checked: Array.isArray(
                  _vm.$editNewOrder.extra_options.possible_early
                )
                  ? _vm._i(
                      _vm.$editNewOrder.extra_options.possible_early,
                      null
                    ) > -1
                  : _vm.$editNewOrder.extra_options.possible_early,
              },
              on: {
                change: function ($event) {
                  var $$a = _vm.$editNewOrder.extra_options.possible_early,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 &&
                        _vm.$set(
                          _vm.$editNewOrder.extra_options,
                          "possible_early",
                          $$a.concat([$$v])
                        )
                    } else {
                      $$i > -1 &&
                        _vm.$set(
                          _vm.$editNewOrder.extra_options,
                          "possible_early",
                          $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                        )
                    }
                  } else {
                    _vm.$set(
                      _vm.$editNewOrder.extra_options,
                      "possible_early",
                      $$c
                    )
                  }
                },
              },
            }),
            _vm._v(" "),
            _c(
              "label",
              { staticClass: "form-check-label", attrs: { for: "gridCheck3" } },
              [
                _vm._v(
                  "\n        Привезти раньше при наличии препаратов\n      "
                ),
              ]
            ),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }